import { request } from "./http";
import type { SubscriptionPlan, UserSubscription } from "../types";

/**
 * Get all available subscription plans
 */
export async function getPlans(): Promise<SubscriptionPlan[]> {
    const response = await request<SubscriptionPlan[]>("/api/plans", {
        method: "GET",
    });
    if (!response.ok) throw new Error(response.error);
    return response.data;
}

/**
 * Create a Stripe Checkout session
 */
export async function createCheckoutSession(
    planId: number,
    billingPeriod: "monthly" | "annual"
): Promise<{ url: string }> {
    const response = await request<{ url: string }>(
        "/api/checkout/create-session",
        {
            method: "POST",
            body: JSON.stringify({ planId, billingPeriod }),
        }
    );
    if (!response.ok) throw new Error(response.error);
    return response.data;
}

/**
 * Get current user's subscription
 */
export async function getCurrentSubscription(): Promise<{
    subscription: UserSubscription | null;
}> {
    const response = await request<{ subscription: UserSubscription | null }>(
        "/api/subscriptions/current",
        {
            method: "GET",
        }
    );
    if (!response.ok) throw new Error(response.error);
    return response.data;
}

/**
 * Cancel current subscription
 */
export async function cancelSubscription(): Promise<{ message: string }> {
    const response = await request<{ message: string }>(
        "/api/subscriptions/cancel",
        {
            method: "POST",
        }
    );
    if (!response.ok) throw new Error(response.error);
    return response.data;
}
